// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"af2f473f","396":"e0240847","397":"889dcc04","421":"25b1d5ea","655":"493e975e","788":"a6672166"}[chunkId] + ".chunk.css";
};